export const TREND_DATA = [
  { value: 'BS249', color: '#006AA6' },
  { value: 'FA075', color: '#F5CBA3' },
  { value: 'FA076', color: '#C3D785' },
  { value: 'FA077', color: '#E3A2A7' },
]

export const EACH_YEAR_DATA = {
  PIE: [
    { value: 'FA078', color: '#006AA6' },
    { value: 'FA079', color: '#F5CBA3' },
    { value: 'FA080', color: '#C3D785' },
    { value: 'FA081', color: '#E3A2A7' },
  ],
  EXPOSURE: [
    { value: 'FA112', color: '#006AA6' },
    { value: 'FA113', color: '#F5CBA3' },
  ],
}
